module.exports = __webpack_public_path__ + "static/Info-cf11b64c8547ab8d7571ae4ef6fef345.png";